import { configureStore, createListenerMiddleware } from "@reduxjs/toolkit";
import searchDataSlice from "./search";
import { flightsSlice, hotelsSlice } from "./filter-sort";
import orderSlice from "./order";
import bookingSlice from "./booking";
import catalogueSlice, { catalogueMiddleware } from "./catalogue";
import cartOverviewSlice, { cartMiddleware } from "./cartOverview";
import bookingUpdatesSlice from "./bookingUpdates";
import tourBookingSlice from "./tourBooking";
import favoritesSlice, { favoritesMiddleware } from "./favorites";

const listenerMiddleware = createListenerMiddleware();

const store = configureStore({
  reducer: {
    search: searchDataSlice,
    flights: flightsSlice.reducer,
    hotels: hotelsSlice.reducer,
    order: orderSlice,
    booking: bookingSlice,
    catalogue: catalogueSlice,
    cartOverview: cartOverviewSlice,
    bookingUpdates: bookingUpdatesSlice,
    tourBooking: tourBookingSlice,
    favorites: favoritesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
      .concat([cartMiddleware, catalogueMiddleware, favoritesMiddleware]),
});

export default store;
